module.exports = __webpack_public_path__ + "img/lake-cabin-6.ae97b071.jpg";